import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    sessions: {
        data: [],
        page: 1,
        page_size: 60,
        totalPage: 1,
        total: 0,
        loading: true,
        type: 'non_ended',
        dateFilter: 0,
    },
    sessionDetail: {
        data: null,
        loading: false,
    },
};

export const sessionSlice = createSlice({
    name: "session",
    initialState,
    reducers: {
        handleSessionData: (state, action) => {
            if (action.payload.sessions) {
                const incoming = action.payload.sessions;
                state.sessions = {
                    ...state.sessions,
                    ...incoming,
                    loading: incoming.loading ?? false,
                };
            }
        },
        handleSessionDetailData: (state, action) => {
            state.sessionDetail = {
                ...state.sessionDetail,
                ...action.payload,
            };
        },
    },
});

export const { handleSessionData, handleSessionDetailData } = sessionSlice.actions;
export default sessionSlice;
